<template>
  <!-- Teleported into the hovered day column, which is the positioning context vue-cal
       lays its events out in — so the ghost lines up with them exactly. -->
  <Teleport v-if="preview.visible && preview.host" :to="preview.host">
    <div
      class="calendar-drop-indicator"
      :style="{ top: `${preview.top}px`, height: `${preview.height}px` }"
    >
      <span class="calendar-drop-indicator__time">{{ preview.label }}</span>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
defineProps<{
  preview: {
    visible: boolean;
    host: HTMLElement | null;
    top: number;
    height: number;
    label: string;
  };
}>();
</script>

<style scoped lang="scss">
.calendar-drop-indicator {
  position: absolute;
  inset-inline: 0;
  z-index: 4;
  // Never intercept the pointer: the drag needs to keep hit-testing the cell underneath.
  pointer-events: none;
  border: 2px dashed rgb(var(--primary));
  border-radius: 0.5rem;
  background: rgb(var(--primary) / 0.12);
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
}

.calendar-drop-indicator__time {
  margin: 2px;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgb(var(--primary));
  color: #fff;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  direction: ltr;
}
</style>
